import {swal_util} from "../../lib/SwalUtil.ts";
import type {FormEvent} from "react";
import {network, PortForwardingAPIConnectorError,} from "../../lib/Network.ts";
import type {InstanceDataProps, Port} from "../../lib/ModelTypes.ts";
import {addPort} from "../../util/PortForwardingAddUtil.tsx";
import i18n from "i18next";

export const portForwardingDialogManager = {
    portRuleList: [],
    async onSubmit(e: FormEvent<HTMLFormElement>, instanceId: number, proto: string, port: string, setData: (data: (prev: InstanceDataProps) => InstanceDataProps) => void) {
        e.preventDefault();
        if (port === '') {
            await swal_util.show_warning(i18n.t("portForwarding.input.enterPort"));
            return;
        }
        if (isNaN(Number(port))) {
            await swal_util.show_warning(i18n.t("portForwarding.input.portMustBeNumber"));
            return;
        }

        const newPort = await addPort(instanceId, proto, Number.parseInt(port, 10),);
        if (newPort) {
            this.onSuccessAddPortRule(newPort, setData);
        }

        return false;
    },

    onSuccessAddPortRule(data: Port, setData: (data: (prev: InstanceDataProps) => InstanceDataProps) => void) {
        const newRow = {
            id: data.id,
            proto: data.proto,
            intern_port: data.intern_port,
            extern_port: data.extern_port,
        }
        setData((prev: InstanceDataProps): InstanceDataProps => ({
            ...prev,
            portTableData: [...prev.portTableData, newRow as Port],
        }));
    },

    async onClickDelete(instanceId: number, protocol: string, internPort: number, portId: number, dataIndex: number, setData: (data: (prev: InstanceDataProps) => InstanceDataProps) => void) {
        try {
            await network.deletePort(instanceId, protocol, internPort, portId);
            this.onDeleteSuccess(dataIndex, setData)
        } catch (err) {
            if (err instanceof PortForwardingAPIConnectorError) {
                await swal_util.show_error(`${err.localization}`);
            } else {
                await swal_util.show_error(i18n.t("portForwarding.errors.deleteFailed"));
            }
            console.error(err);
        }
    },
    onDeleteSuccess(index: number, setData: (data: (prev: InstanceDataProps) => InstanceDataProps) => void) {
        setData((prev: InstanceDataProps) => {
            const newData = prev.portTableData.filter((_, i) => i !== index);
            return {...prev, portTableData: newData};
        });
    },

    async show(instanceId: number, showModal: (open: boolean) => void, setData: (data: (prev: InstanceDataProps) => InstanceDataProps) => void) {
        try {
            const port = await network.portForwardRule.getPortListByServerId(instanceId);
            setData((prev: InstanceDataProps) => ({...prev, portTableData: port!.data.data}));
            showModal(true);
        } catch (err) {
            if (err instanceof PortForwardingAPIConnectorError) {
                await swal_util.show_error(`${err.localization}`);
            } else {
                await swal_util.show_error(i18n.t("portForwarding.errors.fetchRulesFailed"));
            }
            console.error(err);
        }
    }
}